export const FEATURE_NAME = "listing-agent-match-on-hdp";

export const withNamespace = str => `${FEATURE_NAME}/${str}`;
